export default __webpack_public_path__ + "static/media/ep-add.98cdef8e.png";